// shared/voiceMeta.ts — Wertelisten des Sprecher-Bestands (Übergabe-Doc 01,
// VOICE_AGES gegen echten Bestand verifiziert 2026-07-05)
export const CATEGORIES = ['Commercial','Narrative','Documentary','Image','Acting','Synchron','Trailer','VoiceOver','Cartoon','ELearning','IVR','News','Feature','Audiobook','SingingVocal','AudioGuide','Radio','About','Imitation','Poem','StationVoice','Dialog','Corporate','Podcast','Casefilm','Erotic','TV','Promo','Sonstige'] as const;
export const DIALECTS = ['Berlinerisch','Bayerisch','Norddeutsch','Koelsch','Ruhrpott','Saechsisch','Schwaebisch','Rheinisch','Hamburgerisch','Hessisch','Wienerisch','Badisch','Fraenkisch','Plattdeutsch','Pfaelzisch','Unknown'] as const;
export const ACCENTS = ['French','Italian','Russian','German','English','Spanish','Arabic','Dutch','Flemish','Danish','Swedish','Norwegian','Indian','Mexican','Bosnian','British','Australian','Polish','Serbian','Portuguese','Scottish','Croatian','Turkish','Chinese','Japanese','Bulgarian','Romanian','Yiddish','Nigerian','Slovak','Finnish','Hungarian','Asian','Swiss'] as const;
// Sprachen: code = DB/API-Wert (BCP 47), label = deutsche Anzeige,
// fileMarker = Schreibweise im Dateinamen. Konvention: lesbarer ISO-639-2/B-Code
// (3 Buchstaben, aus dem Sprachnamen abgeleitet, z.B. ARM, GEO, SWE) uppercase;
// Majors 2-Buchstaben (EN, FR, IT…); regionale Varianten als BCP-47-Tag (de-AT,
// en-US…). NUR Deutsch (de) hat fileMarker: null — Deutsch erscheint nie im Namen.
// Bestands-Marker bleiben byte-identisch. Liste vollständig nach ISO 639-1.
export const LANGUAGES = [
  { code: 'de',    label: 'Deutsch',                fileMarker: null },
  { code: 'de-AT', label: 'Deutsch (Österreich)',   fileMarker: 'de-AT' },
  { code: 'de-CH', label: 'Deutsch (Schweiz)',      fileMarker: 'de-CH' },
  { code: 'en',    label: 'Englisch',               fileMarker: 'EN' },
  { code: 'en-US', label: 'Englisch (USA)',         fileMarker: 'en-US' },
  { code: 'en-GB', label: 'Englisch (GB)',          fileMarker: 'en-GB' },
  { code: 'en-AU', label: 'Englisch (Australien)',  fileMarker: 'en-AU' },
  { code: 'en-CA', label: 'Englisch (Kanada)',      fileMarker: 'en-CA' },
  { code: 'fr',    label: 'Französisch',            fileMarker: 'FR' },
  { code: 'fr-CH', label: 'Französisch (Schweiz)',  fileMarker: 'fr-CH' },
  { code: 'fr-BE', label: 'Französisch (Belgien)',  fileMarker: 'fr-BE' },
  { code: 'it',    label: 'Italienisch',            fileMarker: 'IT' },
  { code: 'it-CH', label: 'Italienisch (Schweiz)',  fileMarker: 'it-CH' },
  { code: 'es',    label: 'Spanisch',               fileMarker: 'ES' },
  { code: 'nl',    label: 'Niederländisch',         fileMarker: 'NL' },
  { code: 'nl-BE', label: 'Flämisch (Belgien)',     fileMarker: 'nl-BE' },
  { code: 'pt',    label: 'Portugiesisch',          fileMarker: 'PT' },
  { code: 'ru',    label: 'Russisch',               fileMarker: 'RU' },
  { code: 'pl',    label: 'Polnisch',               fileMarker: 'PL' },
  { code: 'tr',    label: 'Türkisch',               fileMarker: 'TR' },
  { code: 'sv',    label: 'Schwedisch',             fileMarker: 'SWE' },
  { code: 'no',    label: 'Norwegisch',             fileMarker: 'NOR' },
  { code: 'da',    label: 'Dänisch',                fileMarker: 'DAN' },
  { code: 'fi',    label: 'Finnisch',               fileMarker: 'FIN' },
  { code: 'is',    label: 'Isländisch',             fileMarker: 'ICE' },
  { code: 'hi',    label: 'Hindi',                  fileMarker: 'HIN' },
  { code: 'ar',    label: 'Arabisch',               fileMarker: 'ARA' },
  { code: 'ja',    label: 'Japanisch',              fileMarker: 'JPN' },
  { code: 'ko',    label: 'Koreanisch',             fileMarker: 'KOR' },
  { code: 'zh',    label: 'Chinesisch (Mandarin)',  fileMarker: 'CHI' },
  { code: 'bg',    label: 'Bulgarisch',             fileMarker: 'BUL' },
  { code: 'sk',    label: 'Slowakisch',             fileMarker: 'SLO' },
  { code: 'cs',    label: 'Tschechisch',            fileMarker: 'CZE' },
  { code: 'ro',    label: 'Rumänisch',              fileMarker: 'RUM' },
  { code: 'hu',    label: 'Ungarisch',              fileMarker: 'HUN' },
  { code: 'th',    label: 'Thai',                   fileMarker: 'THA' },
  { code: 'el',    label: 'Griechisch',             fileMarker: 'GRE' },
  { code: 'ca',    label: 'Katalanisch',            fileMarker: 'CAT' },
  { code: 'sr',    label: 'Serbisch',               fileMarker: 'SRP' },
  { code: 'hr',    label: 'Kroatisch',              fileMarker: 'HRV' },
  { code: 'sl',    label: 'Slowenisch',             fileMarker: 'SLV' },
  { code: 'sq',    label: 'Albanisch',              fileMarker: 'ALB' },
  { code: 'bs',    label: 'Bosnisch',               fileMarker: 'BOS' },
  { code: 'fa',    label: 'Persisch (Farsi)',       fileMarker: 'PER' },
  { code: 'ga',    label: 'Irisch (Gälisch)',       fileMarker: 'GLE' },
  { code: 'ku',    label: 'Kurdisch',               fileMarker: 'KUR' },
  { code: 'mt',     label: 'Maltesisch',              fileMarker: 'MLT' },
  { code: 'lv',     label: 'Lettisch',                fileMarker: 'LAV' },
  { code: 'et',     label: 'Estnisch',                fileMarker: 'EST' },
  { code: 'tg',     label: 'Tadschikisch',            fileMarker: 'TGK' },
  { code: 'ln',     label: 'Lingala',                 fileMarker: 'LIN' },
  { code: 'sw',     label: 'Swahili',                 fileMarker: 'SWA' },
  { code: 'mk',     label: 'Mazedonisch',             fileMarker: 'MAC' },
  { code: 'uk',     label: 'Ukrainisch',              fileMarker: 'UKR' },
  { code: 'he',     label: 'Hebräisch',               fileMarker: 'HEB' },
  { code: 'rm',     label: 'Rätoromanisch',           fileMarker: 'ROH' },
  { code: 'ta',     label: 'Tamil',                   fileMarker: 'TAM' },
  { code: 'id',     label: 'Indonesisch',             fileMarker: 'IND' },
  { code: 'vi',     label: 'Vietnamesisch',           fileMarker: 'VIE' },
  { code: 'lb',     label: 'Luxemburgisch',           fileMarker: 'LTZ' },
  { code: 'fr-CA',  label: 'Französisch (Kanada)',    fileMarker: 'fr-CA' },
  { code: 'pt-BR',  label: 'Portugiesisch (Brasilien)', fileMarker: 'pt-BR' },
  { code: 'es-419', label: 'Spanisch (Lateinamerika)', fileMarker: 'es-419' },
  { code: 'en-NZ',  label: 'Englisch (Neuseeland)',   fileMarker: 'en-NZ' },
  // Etappe 5.5 — vollständige ISO-639-1-Basissprachen (deutsche Labels).
  // fileMarker = lesbarer ISO-639-2/B-Code (Batch C, 2026-07-10) — damit auch
  // Uploads in diesen Sprachen einen Sprach-Marker im Dateinamen tragen.
  { code: 'aa',     label: 'Afar',                    fileMarker: 'AAR' },
  { code: 'ab',     label: 'Abchasisch',              fileMarker: 'ABK' },
  { code: 'ae',     label: 'Avestisch',               fileMarker: 'AVE' },
  { code: 'af',     label: 'Afrikaans',               fileMarker: 'AFR' },
  { code: 'ak',     label: 'Akan',                    fileMarker: 'AKA' },
  { code: 'am',     label: 'Amharisch',               fileMarker: 'AMH' },
  { code: 'an',     label: 'Aragonesisch',            fileMarker: 'ARG' },
  { code: 'as',     label: 'Assamesisch',             fileMarker: 'ASM' },
  { code: 'av',     label: 'Awarisch',                fileMarker: 'AVA' },
  { code: 'ay',     label: 'Aymara',                  fileMarker: 'AYM' },
  { code: 'az',     label: 'Aserbaidschanisch',       fileMarker: 'AZE' },
  { code: 'ba',     label: 'Baschkirisch',            fileMarker: 'BAK' },
  { code: 'be',     label: 'Belarussisch',            fileMarker: 'BEL' },
  { code: 'bh',     label: 'Bihari',                  fileMarker: 'BIH' },
  { code: 'bi',     label: 'Bislama',                 fileMarker: 'BIS' },
  { code: 'bm',     label: 'Bambara',                 fileMarker: 'BAM' },
  { code: 'bn',     label: 'Bengalisch',              fileMarker: 'BEN' },
  { code: 'bo',     label: 'Tibetisch',               fileMarker: 'TIB' },
  { code: 'br',     label: 'Bretonisch',              fileMarker: 'BRE' },
  { code: 'ce',     label: 'Tschetschenisch',         fileMarker: 'CHE' },
  { code: 'ch',     label: 'Chamorro',                fileMarker: 'CHA' },
  { code: 'co',     label: 'Korsisch',                fileMarker: 'COS' },
  { code: 'cr',     label: 'Cree',                    fileMarker: 'CRE' },
  { code: 'cu',     label: 'Kirchenslawisch',         fileMarker: 'CHU' },
  { code: 'cv',     label: 'Tschuwaschisch',          fileMarker: 'CHV' },
  { code: 'cy',     label: 'Walisisch',               fileMarker: 'WEL' },
  { code: 'dv',     label: 'Dhivehi (Maledivisch)',   fileMarker: 'DIV' },
  { code: 'dz',     label: 'Dzongkha',                fileMarker: 'DZO' },
  { code: 'ee',     label: 'Ewe',                     fileMarker: 'EWE' },
  { code: 'eo',     label: 'Esperanto',               fileMarker: 'EPO' },
  { code: 'eu',     label: 'Baskisch',                fileMarker: 'BAQ' },
  { code: 'ff',     label: 'Fulfulde',                fileMarker: 'FUL' },
  { code: 'fj',     label: 'Fidschianisch',           fileMarker: 'FIJ' },
  { code: 'fo',     label: 'Färöisch',                fileMarker: 'FAO' },
  { code: 'fy',     label: 'Westfriesisch',           fileMarker: 'FRY' },
  { code: 'gd',     label: 'Schottisch-Gälisch',      fileMarker: 'GLA' },
  { code: 'gl',     label: 'Galicisch',               fileMarker: 'GLG' },
  { code: 'gn',     label: 'Guaraní',                 fileMarker: 'GRN' },
  { code: 'gu',     label: 'Gujarati',                fileMarker: 'GUJ' },
  { code: 'gv',     label: 'Manx',                    fileMarker: 'GLV' },
  { code: 'ha',     label: 'Hausa',                   fileMarker: 'HAU' },
  { code: 'ho',     label: 'Hiri Motu',               fileMarker: 'HMO' },
  { code: 'ht',     label: 'Haitianisch',             fileMarker: 'HAT' },
  { code: 'hy',     label: 'Armenisch',               fileMarker: 'ARM' },
  { code: 'hz',     label: 'Herero',                  fileMarker: 'HER' },
  { code: 'ia',     label: 'Interlingua',             fileMarker: 'INA' },
  { code: 'ie',     label: 'Interlingue',             fileMarker: 'ILE' },
  { code: 'ig',     label: 'Igbo',                    fileMarker: 'IBO' },
  { code: 'ii',     label: 'Yi (Nuosu)',              fileMarker: 'III' },
  { code: 'ik',     label: 'Inupiaq',                 fileMarker: 'IPK' },
  { code: 'io',     label: 'Ido',                     fileMarker: 'IDO' },
  { code: 'iu',     label: 'Inuktitut',               fileMarker: 'IKU' },
  { code: 'jv',     label: 'Javanisch',               fileMarker: 'JAV' },
  { code: 'ka',     label: 'Georgisch',               fileMarker: 'GEO' },
  { code: 'kg',     label: 'Kongo',                   fileMarker: 'KON' },
  { code: 'ki',     label: 'Kikuyu',                  fileMarker: 'KIK' },
  { code: 'kj',     label: 'Kwanyama',                fileMarker: 'KUA' },
  { code: 'kk',     label: 'Kasachisch',              fileMarker: 'KAZ' },
  { code: 'kl',     label: 'Grönländisch',            fileMarker: 'KAL' },
  { code: 'km',     label: 'Khmer',                   fileMarker: 'KHM' },
  { code: 'kn',     label: 'Kannada',                 fileMarker: 'KAN' },
  { code: 'kr',     label: 'Kanuri',                  fileMarker: 'KAU' },
  { code: 'ks',     label: 'Kaschmiri',               fileMarker: 'KAS' },
  { code: 'kv',     label: 'Komi',                    fileMarker: 'KOM' },
  { code: 'kw',     label: 'Kornisch',                fileMarker: 'COR' },
  { code: 'ky',     label: 'Kirgisisch',              fileMarker: 'KIR' },
  { code: 'la',     label: 'Latein',                  fileMarker: 'LAT' },
  { code: 'lg',     label: 'Ganda',                   fileMarker: 'LUG' },
  { code: 'li',     label: 'Limburgisch',             fileMarker: 'LIM' },
  { code: 'lo',     label: 'Laotisch',                fileMarker: 'LAO' },
  { code: 'lt',     label: 'Litauisch',               fileMarker: 'LIT' },
  { code: 'lu',     label: 'Luba-Katanga',            fileMarker: 'LUB' },
  { code: 'mg',     label: 'Malagassisch',            fileMarker: 'MLG' },
  { code: 'mh',     label: 'Marshallesisch',          fileMarker: 'MAH' },
  { code: 'mi',     label: 'Maori',                   fileMarker: 'MAO' },
  { code: 'ml',     label: 'Malayalam',               fileMarker: 'MAL' },
  { code: 'mn',     label: 'Mongolisch',              fileMarker: 'MON' },
  { code: 'mr',     label: 'Marathi',                 fileMarker: 'MAR' },
  { code: 'ms',     label: 'Malaiisch',               fileMarker: 'MAY' },
  { code: 'my',     label: 'Birmanisch',              fileMarker: 'BUR' },
  { code: 'na',     label: 'Nauruisch',               fileMarker: 'NAU' },
  { code: 'nb',     label: 'Norwegisch (Bokmål)',     fileMarker: 'NOB' },
  { code: 'nd',     label: 'Nord-Ndebele',            fileMarker: 'NDE' },
  { code: 'ne',     label: 'Nepali',                  fileMarker: 'NEP' },
  { code: 'ng',     label: 'Ndonga',                  fileMarker: 'NDO' },
  { code: 'nn',     label: 'Norwegisch (Nynorsk)',    fileMarker: 'NNO' },
  { code: 'nr',     label: 'Süd-Ndebele',             fileMarker: 'NBL' },
  { code: 'nv',     label: 'Navajo',                  fileMarker: 'NAV' },
  { code: 'ny',     label: 'Chichewa',                fileMarker: 'NYA' },
  { code: 'oc',     label: 'Okzitanisch',             fileMarker: 'OCI' },
  { code: 'oj',     label: 'Ojibwe',                  fileMarker: 'OJI' },
  { code: 'om',     label: 'Oromo',                   fileMarker: 'ORM' },
  { code: 'or',     label: 'Oriya',                   fileMarker: 'ORI' },
  { code: 'os',     label: 'Ossetisch',               fileMarker: 'OSS' },
  { code: 'pa',     label: 'Panjabi',                 fileMarker: 'PAN' },
  { code: 'pi',     label: 'Pali',                    fileMarker: 'PLI' },
  { code: 'ps',     label: 'Paschtu',                 fileMarker: 'PUS' },
  { code: 'qu',     label: 'Quechua',                 fileMarker: 'QUE' },
  { code: 'rn',     label: 'Kirundi',                 fileMarker: 'RUN' },
  { code: 'rw',     label: 'Kinyarwanda',             fileMarker: 'KIN' },
  { code: 'sa',     label: 'Sanskrit',                fileMarker: 'SAN' },
  { code: 'sc',     label: 'Sardisch',                fileMarker: 'SRD' },
  { code: 'sd',     label: 'Sindhi',                  fileMarker: 'SND' },
  { code: 'sg',     label: 'Sango',                   fileMarker: 'SAG' },
  { code: 'si',     label: 'Singhalesisch',           fileMarker: 'SIN' },
  { code: 'sm',     label: 'Samoanisch',              fileMarker: 'SMO' },
  { code: 'sn',     label: 'Shona',                   fileMarker: 'SNA' },
  { code: 'so',     label: 'Somali',                  fileMarker: 'SOM' },
  { code: 'ss',     label: 'Swati',                   fileMarker: 'SSW' },
  { code: 'st',     label: 'Süd-Sotho',               fileMarker: 'SOT' },
  { code: 'su',     label: 'Sundanesisch',            fileMarker: 'SUN' },
  { code: 'te',     label: 'Telugu',                  fileMarker: 'TEL' },
  { code: 'ti',     label: 'Tigrinya',                fileMarker: 'TIR' },
  { code: 'tk',     label: 'Turkmenisch',             fileMarker: 'TUK' },
  { code: 'tl',     label: 'Tagalog',                 fileMarker: 'TGL' },
  { code: 'tn',     label: 'Tswana',                  fileMarker: 'TSN' },
  { code: 'to',     label: 'Tongaisch',               fileMarker: 'TON' },
  { code: 'ts',     label: 'Tsonga',                  fileMarker: 'TSO' },
  { code: 'tt',     label: 'Tatarisch',               fileMarker: 'TAT' },
  { code: 'tw',     label: 'Twi',                     fileMarker: 'TWI' },
  { code: 'ty',     label: 'Tahitianisch',            fileMarker: 'TAH' },
  { code: 'ug',     label: 'Uigurisch',               fileMarker: 'UIG' },
  { code: 'ur',     label: 'Urdu',                    fileMarker: 'URD' },
  { code: 'uz',     label: 'Usbekisch',               fileMarker: 'UZB' },
  { code: 've',     label: 'Venda',                   fileMarker: 'VEN' },
  { code: 'vo',     label: 'Volapük',                 fileMarker: 'VOL' },
  { code: 'wa',     label: 'Wallonisch',              fileMarker: 'WLN' },
  { code: 'wo',     label: 'Wolof',                   fileMarker: 'WOL' },
  { code: 'xh',     label: 'Xhosa',                   fileMarker: 'XHO' },
  { code: 'yi',     label: 'Jiddisch',                fileMarker: 'YID' },
  { code: 'yo',     label: 'Yoruba',                  fileMarker: 'YOR' },
  { code: 'za',     label: 'Zhuang',                  fileMarker: 'ZHA' },
  { code: 'zu',     label: 'Zulu',                    fileMarker: 'ZUL' },
] as const;
export const LANGUAGE_CODES = LANGUAGES.map((l) => l.code) as unknown as readonly string[];
// Altbestand, wird durch Batch-Korrektur ersetzt — danach entfernen (siehe Plan Task 8).
export const LEGACY_LANGUAGE_CODES = ['dk','cn','cz','gr','se'] as const;
export const LANGUAGE_LABEL: Record<string, string> = Object.fromEntries(LANGUAGES.map((l) => [l.code, l.label]));
export const FILE_MARKERS: Record<string, string | null> = Object.fromEntries(LANGUAGES.map((l) => [l.code, l.fileMarker]));
// Etappe 2 — Konditionen + Herkunft.
export const CURRENCIES = ['€', '$'] as const;
export type Currency = typeof CURRENCIES[number];

// Brandvoice (Etappe 8) — interner Bereich pro Sprecher.
export const BRANDVOICE_REGIONS = ['US', 'EU', 'US+EU'] as const;
export type BrandvoiceRegion = typeof BRANDVOICE_REGIONS[number];

export const VOICE_AGES = ['0-10','11-18','19-39','40-59','60-100'] as const;
export const VOICE_GENDERS = ['m','w','d'] as const;
export const DISTANCE_VALUES = ['nah', 'fern', 'Berlin'] as const;
export const VOICE_STATUS = ['aktiv','archiviert','unvollstaendig'] as const;
export const VOICE_SORTS = ['name','ranking','updated','gender','status','ort'] as const;
// Vokabular-Arten (DB-gestützt, Etappe 5.5) — Sprachen bleiben feste Const-Liste.
export const VOCAB_KINDS = ['dialect','accent','category'] as const;
export const TAG_CATEGORIES = ['voice','skill','accent','internal','platform'] as const;
export type VoiceCategory = typeof CATEGORIES[number];
export type VoiceDialect = typeof DIALECTS[number];
export type VoiceAccent = typeof ACCENTS[number];
export type VoiceLanguage = typeof LANGUAGES[number]['code'];
export type VoiceAgeRange = typeof VOICE_AGES[number];
export type VoiceGender = typeof VOICE_GENDERS[number];
export type VoiceDistance = typeof DISTANCE_VALUES[number];
export type VoiceStatus = typeof VOICE_STATUS[number];
export type VoiceSort = typeof VOICE_SORTS[number];
export type TagCategory = typeof TAG_CATEGORIES[number];
